// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const getNativeAuthorizationQueryParamsSchema = z.object({
  client_id: z.optional(z.coerce.string().describe("OAuth 2.0 client identifier")),
  redirect_uri: z.optional(z.coerce.string().describe("OAuth 2.0 redirect URI")),
  response_type: z.optional(z.coerce.string().describe("OAuth 2.0 response type")),
  scope: z.optional(z.coerce.string().describe("OAuth 2.0 requested scope")),
  state: z.optional(z.coerce.string().describe("OAuth 2.0 state parameter")),
}).optional();

/**
 * @description native authorization page
 */
export const getNativeAuthorization200Schema = z.unknown();

export const getNativeAuthorizationQueryResponseSchema = z.lazy(() => getNativeAuthorization200Schema);
